import { BottomSheetContent as L2RBottomSheetContent, styled } from "@l2r-front/l2r-ui"

import { DocumentFilterList as L2RDocumentFilterList } from "../DocumentFilterList"

export const BottomSheetContent = styled(L2RBottomSheetContent)(({ theme }) => ({
    backgroundColor: theme.palette["common/gray_states/light"].main,
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
    position: "relative",
}))


export const DocumentFilterList = styled(L2RDocumentFilterList)(({ theme }) => ({
    padding: theme.spacing(0, 3, 0, 0),
}))